namespace Matrix.Dashboards {
    export enum ChartType {
        Line = 1,
        Bar = 2,
        Pie = 3,
        Doughnut = 4,
        PolarArea = 5,
        Radar = 6,
        Scatter = 7,
        Bubble = 8
    }
    Serenity.Decorators.registerEnumType(ChartType, 'Matrix.Dashboards.ChartType');
}
